import { GetCampaignRes } from "../api";
// 頁面與後端都檢查時間，避免批次狀態尚未更新時仍可捐款。
export function campaignEnded(campaign?: GetCampaignRes, now = Date.now()) {
  return (
    !!campaign && new Date(campaign.expectedEndDate || "").getTime() <= now
  );
}
export function campaignAcceptsDonations(
  campaign?: GetCampaignRes,
  now = Date.now(),
) {
  return (
    !!campaign &&
    campaign.isApproved !== false &&
    !["paused", "cancelled", "expired", "completed"].includes(
      campaign.status || "",
    ) &&
    new Date(campaign.expectedLaunchDate || "").getTime() <= now &&
    !campaignEnded(campaign, now)
  );
}
export function campaignEarnedMedal(campaign?: GetCampaignRes) {
  return (
    campaignEnded(campaign) &&
    Number(campaign?.goalAmount) > 0 &&
    Number(campaign?.raisedAmount) >= Number(campaign?.goalAmount)
  );
}
export function hongKongDay(date: Date) {
  return new Date(date.getTime() + 8 * 3600000).toISOString().slice(0, 10);
}
